module.exports = __webpack_public_path__ + "img/bcc161.179bdf36.jpeg";